<template>
  <!-- 图片分类 -->
  <div class="dataset-classify">
    <classification></classification>
  </div>
</template>

<script>
import Classification from '@/components/pretrain/Classification.vue'

export default {
  name: 'dataset-classify',
  components: { Classification },
  props: [],
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped></style>
